import InputText from './form/input-text'
import InputSelect from './form/input-select'
import InputToggle from './form/input-toggle'
import InputDate from './form/input-date'
import Quote from './ferment/quote'

export default function registerVueComponents(Vue) {
	Vue.component('input-text', InputText);
	Vue.component('input-select', InputSelect);
	Vue.component('input-toggle', InputToggle);
	Vue.component('input-date', InputDate);
  Vue.component('quote', Quote);
}



// WEBPACK FOOTER //
// ./src/components/index.js